
/**
 * Le block <clock-destination> appelé pour afficher l'heure courante à un fuseau horaire donné
 * DOC : https://developer.mozilla.org/fr/docs/Web/API/Web_components/Using_custom_elements
 */
class clock extends HTMLElement {
		constructor() {

			super();
			this.shadow = this.attachShadow({ mode: "open" });

			this.timezone = this.dataset.timezone === undefined ? "Europe/Paris" : this.dataset.timezone;
			this.titre = this.dataset.titre === undefined ? "Heure à Paris" : this.dataset.titre;

			this.options = {
				hour: "numeric",
				minute: "numeric",
				timeZone: this.timezone,
			};

		}
		pushTime() {
			let minutes = this.shadowRoot.getElementById('minutes'),
			hours = this.shadowRoot.getElementById('hours');
			let arr = new Intl.DateTimeFormat('fr-fr', this.options).format(new Date()).split(':');
			hours.innerHTML = arr[0];
			minutes.innerHTML= arr[1];
		}
		connectedCallback() {
			let self = this;
			this.render();

			// On init
			this.pushTime();

			// Maj toutes les minutes
			setInterval(function() {
				self.pushTime();
			}, 60000);

			document.addEventListener('show:widget', () => {
				self.hidden = !self.hidden
			})
		}

		render() {

			this.shadowRoot.innerHTML = `
				<style>.bloc--widget {
				padding-top:30px;
				padding-bottom:30px;
				}
        .bloc__titre {
					color:  var(--app-color-primary);
					font-size: var(--app-fontSize-base);
					font-weight: 700;
					line-height: 1;
				}
				.widget--time {
					max-width: 255px;
					background: #efefef;
					border-radius: 12px;
					display: flex;
					font-size: 34px;
					font-weight: 300;
					justify-content: center;
					line-height: 42px;
					padding-bottom: 10px;
					padding-top: 5px;
				}
				#hours:after {
					animation-duration: 2s;
					animation-name: flash;
					content: attr(data-separator);
					padding-left:  10px;
					padding-right: 10px;
					animation-fill-mode: both;
					animation-iteration-count: infinite;
				}

				@keyframes flash {
					from,
					50%,
					to {
						opacity: 1;
					}

					25%,
					75% {
						opacity: 0;
					}
				}
	</style>


				<div class="bloc bloc--widget" id="widgetTime">
		<h3 class="bloc__titre">${this.titre}</h3>
		<div class="widget--time widget">
				<div id="hours" data-separator=":"></div><div id="minutes"></div>
		</div>
</div>`;
		}
}
customElements.define("clock-destination", clock);
